module.exports = __webpack_public_path__ + "static/media/3.1e9cff2f.png";